var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "hasPermi",
                  rawName: "v-hasPermi",
                  value: ["admin:system:config:clear:cache"],
                  expression: "['admin:system:config:clear:cache']",
                },
                {
                  name: "debounceClick",
                  rawName: "v-debounceClick",
                  value: _vm.handleClear,
                  expression: "handleClear",
                },
              ],
              attrs: { type: "primary" },
            },
            [_vm._v("清除缓存")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }